<template lang='pug'>
  div
    CurrentTime
    .container
      button.entrada(@click="record") COM VOZ (1)
    //- .preciso garantir a permissão para utilizar o seu microfone.
      //- v-if, outro botão com essa string e  esse vai pro v-else com iniciar gravacao
</template>
<script>

// TODO trazer o kind da página de pontos para a de voice
// TODO pegar geolocation da pagina anterior
// TODO enviar o arquivo de audio pela api
// TODO fazer encoding p/ mp3
// TODO fazer o outro botão antes de iniciar a gravação

import CurrentTime from '@/common/CurrentTime.vue'

export default {
  components: {
    CurrentTime
  },
  computed: {
    info () {
      const {accessData} = this.$store.state
      return {
        employee: accessData.employeeId,
        fingerprint: accessData.id
      }
    }
  },
  methods: {
    record () {
//      console.log('recording...')
      function hasGetUserMedia () {
        return !!(navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia)
      }
      // recorder available
      if (hasGetUserMedia()) {

        // start to record
        navigator.mediaDevices.getUserMedia({ audio: true })
          .then(stream => {
            const mediaRecorder = new MediaRecorder(stream)
            mediaRecorder.start()
            const audioChunks = []

            // get audio chunks
            mediaRecorder.addEventListener('dataavailable', event => {
              audioChunks.push(event.data)
            })

            // convert all the chunks into a single blob
            mediaRecorder.addEventListener('stop', () => {
              const audioBlob = new Blob(audioChunks)
//              console.log('audioBlob: ', audioBlob)
              // creates a url used to play the audio
              // const audioUrl = URL.createObjectURL(audioBlob)
              // creates an audio with the url
              // const audio = new Audio(audioUrl)
              // console.log(audioUrl)
              // play the audio
              // audio.play()
            })

            // stop recording
            setTimeout(() => {
              mediaRecorder.stop()
            }, 3000)
          })
      } else {
        alert('getUserMedia() is not supported by your browser')
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows:  repeat(3, 1fr);
  grid-column-gap: .5rem;
  grid-row-gap: .5rem;
  height: 20vh;
  align-content: center;
}
.entrada {
  grid-row-start: 1;
  grid-row-end: 4;
  grid-column-start: 2;
  background-color: #0C9B73;
  color: white;
}
</style>
